var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { TopToolbar } from 'react-admin';
import { Edit } from '../ui';
import { ApplicationEditView } from './ApplicationEditView';
import { ApplicationTitle } from './ApplicationTitle';
import { useUserContext } from '../userContexts';
const useStyles = makeStyles({
    root: {},
    card: {},
}, {
    name: 'Layer7ApplicationCreate',
});
const AppEditActions = ({ basePath, data, resource, className }) => {
    return (React.createElement(TopToolbar, { className: className },
        React.createElement("div", null)));
};
export const ApplicationEdit = props => {
    const _a = useStyles(props), { root: rootClassName } = _a, classes = __rest(_a, ["root"]);
    const { permissions, id } = props, rest = __rest(props, ["permissions", "id"]);
    const [userContext] = useUserContext();
    if (!userContext) {
        return null;
    }
    return (React.createElement(Edit, Object.assign({ className: rootClassName, classes: classes, title: React.createElement(ApplicationTitle, null), actions: React.createElement(AppEditActions, { className: classes.topToolbar }) }, props),
        React.createElement(ApplicationEditView, { userContext: userContext })));
};
//# sourceMappingURL=ApplicationEdit.js.map